import { invokeApi } from "../../bl_libs/invokeApi";

export const verify_activation_token_api = async (token, schoolId) => {
  const requestObj = {
    path: `api/school/verify-activation-token`,
    method: "GET",
    headers: {},
    queryParams: {
      token,
      school_id: schoolId,
    },
  };
  return invokeApi(requestObj);
};

export const activate_admin_account_api = async (data) => {
  const requestObj = {
    path: `api/school/activate-account`,
    method: "POST",
    headers: {},
    postData: data,
  };
  return invokeApi(requestObj);
};
